import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../lib/cn";
import {
  isNavigationItemActive,
  type NavigationItem,
} from "./navigationConfig";

export interface SidebarNavProps {
  currentPath: string;
  isExpanded: boolean;
  items: NavigationItem[];
}

interface SidebarNavItemProps {
  currentPath: string;
  isExpanded: boolean;
  item: NavigationItem;
}

const SidebarNavItem = ({ currentPath, isExpanded, item }: SidebarNavItemProps) => {
  const Icon = item.icon;
  const isActive = isNavigationItemActive(item, currentPath);

  return (
    <li>
      <Link
        to={item.to}
        className={cn(
          "group flex items-center rounded-xl p-2.5 text-sm font-medium transition-all duration-200",
          isExpanded ? "justify-start" : "justify-center",
          isActive
            ? "bg-gradient-to-r from-orange-100 to-orange-200 text-orange-600 shadow-sm dark:from-orange-500 dark:to-orange-700 dark:text-white"
            : "text-gray-700 hover:bg-orange-100/70 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-white",
        )}
        aria-current={isActive ? "page" : undefined}
        title={item.label}
      >
        <Icon className="h-5 w-5 shrink-0" />
        {isExpanded ? <span className="ml-3 truncate">{item.label}</span> : null}
      </Link>
    </li>
  );
};

const SidebarNav = ({ currentPath, isExpanded, items }: SidebarNavProps) => {
  return (
    <ul className="space-y-2 font-medium">
      {items.map((item) => (
        <SidebarNavItem
          key={item.id}
          currentPath={currentPath}
          isExpanded={isExpanded}
          item={item}
        />
      ))}
    </ul>
  );
};

export default React.memo(SidebarNav);
